import { useMutation } from "urql";

import { UpdateKycAccurateDocument } from "../../../graphql/generated";

export const useUpdateKycAccurate = () => {
  const [result, executeMutation] = useMutation(UpdateKycAccurateDocument);

  const updateAccurate = (id: number, accurate: boolean) => {
    return executeMutation({ id, accurate });
  };

  return {
    ...result,
    updateAccurate,
  };
};
